import React, { useState, useEffect } from 'react';
import { Redirect } from 'react-router-dom';
import i18next from 'i18next';

import { PageTitle } from '../PageTitle';
import { ChecklistConfigsService } from '../../services';
import ChecklistConfig from './checklist_config';

const ChecklistView = ({ match, location }) => {
  const [checklistConfiguration, setChecklistConfiguration] = useState(null);
  const [errorMessage, setErrorMessage] = useState(null);

  useEffect(() => {
      ChecklistConfigsService.get(match.params.checklistId).then((response) => {
          setChecklistConfiguration(response.checklistConfiguration);
      }).catch((error) => {
          setErrorMessage(i18next.t('messages.could-not-load-checklist-config'));
          console.error(error);
      });
  }, [match]);

  if (errorMessage) {
    return <Redirect to={{ pathname: '/config/checklists', state: { errorMessage: errorMessage } }}/>; 
  } else if (checklistConfiguration) {
      const backLinkWithParams = { link: { pathname: "/config/checklists", search: location.state?.backLinkSearch } };
      const editLinkWithParams = {
        link: {
            pathname: `/config/checklists/edit/${checklistConfiguration.id}`,
            uiroute: '/config/checklists/edit/:checklistId',
            state: { backLinkSearch: location.state?.backLinkSearch }
          }
      };

      return (
          <div>
            <div className="row">
              <PageTitle 
                  title={checklistConfiguration.name}
                  backLinkWithParams={backLinkWithParams}
                  editLinkWithParams={editLinkWithParams}
              />
            </div>

            <div className="op-content-box tree-form">
              <h4 className="remove-margin-bottom"/>
                <div className="row">
                  <ChecklistConfig
                      readOnly={true}
                      originalChecklistConfiguration={checklistConfiguration}
                      backLinkWithParams={backLinkWithParams}/>
                </div>
              </div>
          </div>
      );
  } else {
      return <div className="loader">{i18next.t('loading')}</div>;
  }
}

export default ChecklistView;
